import { format } from "date-fns";

/** YYYY/MM/DD形式変換 */
export const formatDate = (date?: string): string => {
  return format(date || '', "yyyy/MM/dd")
}
